const SubRegions = {
  SOUTHERN_EUROPE: 'southern_europe',
  WESTERN_ASIA: 'western_asia',
  SOUTHERN_ASIA: 'southern_asia',
  LATIN_AMERICA_AND_THE_CARIBBEAN: 'latin_america_and_the_caribbean',
  SUB_SAHARAN_AFRICA: 'sub_saharan_africa',
  ANTARCTICA: 'antartica',
  POLYNESIA: 'polynesia',
  WESTERN_EUROPE: 'western_europe',
  AUSTRALIA_AND_NEW_ZEALAND: 'australia_and_new_zealand',
  NORTHERN_EUROPE: 'northern_europe',
  EASTERN_EUROPE: 'eastern_europe',
  NORTHERN_AMERICA: 'northern_america',
  SOUTH_EASTERN_ASIA: 'south_eastern_asia',
  EASTERN_ASIA: 'eastern_asia',
  NORTHERN_AFRICA: 'northern_africa',
  MELANESIA: 'melanesia',
  MICRONESIA: 'micronesia',
  CENTRAL_ASIA: 'central_asia',
};

module.exports = SubRegions;
